import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Button,
  Box,
} from "@mui/material";
import { Iconify } from "../../../Minimal/src/components/iconify/iconify";
import Edit_Customer from "../../../Master/Customers/Edit_Customer";
import SageCustomerMemosPopup from "./SageCustomerMemosPopup";
import CustomerOrderHistoryPopup from "./CustomerOrderHistoryPopup";
import CustomerLedgerEnquiryPopup from "./CustomerLedgerEnquiryPopup";

const QuickOrderCustomerEditPopup = ({ open, onClose, customer }) => {
  const [memosOpen, setMemosOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [transactionOpen, setTransactionOpen] = useState(false);
  const customerId = customer?.id;

  const headerActions = (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
      <Button
        variant="outlined"
        className="button-variant-outlined"
        size="small"
        startIcon={<Iconify icon="mdi:history" width={18} height={18} />}
        onClick={() => setHistoryOpen(true)}
        sx={{ whiteSpace: "nowrap" }}
      >
        Order History
      </Button>
      <Button
        variant="outlined"
        className="button-variant-outlined"
        size="small"
        startIcon={<Iconify icon="mdi:swap-horizontal" width={18} height={18} />}
        onClick={() => setTransactionOpen(true)}
        sx={{ whiteSpace: "nowrap" }}
      >
        Transaction
      </Button>
      <Button
        variant="outlined"
        className="button-variant-outlined"
        size="small"
        startIcon={<Iconify icon="mdi:note-text-outline" width={18} height={18} />}
        onClick={() => setMemosOpen(true)}
        sx={{ whiteSpace: "nowrap" }}
      >
        Memos
      </Button>
      <IconButton onClick={onClose} size="small">
        <Iconify icon="mdi:close" width={20} height={20} />
      </IconButton>
    </Box>
  );

  return (
    <>
      <Dialog
        open={open && Boolean(customerId)}
        onClose={onClose}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            height: "92vh",
            maxHeight: "92vh",
          },
        }}
      >
        <DialogContent sx={{ p: 0, overflow: "auto" }}>
          {customerId ? (
            <Edit_Customer
              customerId={String(customerId)}
              embedded
              onClose={onClose}
              headerActions={headerActions}
            />
          ) : null}
        </DialogContent>
      </Dialog>
      <SageCustomerMemosPopup
        open={memosOpen}
        onClose={() => setMemosOpen(false)}
        customer={customer}
      />
      <CustomerOrderHistoryPopup
        open={historyOpen}
        customer={customer}
        onClose={() => setHistoryOpen(false)}
      />
      <CustomerLedgerEnquiryPopup
        open={transactionOpen}
        customer={customer}
        onClose={() => setTransactionOpen(false)}
      />
    </>
  );
};

export default QuickOrderCustomerEditPopup;
